export { default } from './AiChatActivityBar';
